module.exports = __webpack_public_path__ + "img/25.03f51006.jpg";